// El id de ambientación es independiente de la zona histórica usada por
// partidas y rankings. Sólo el servidor acredita visitas con coordenadas GPS.
export const GAME_LOCATIONS = [
  { id: 'centro', label: 'Zona Centro', gameZone: 'Centro Histórico' },
  { id: 'norte', label: 'Zona Norte', gameZone: 'Toluca' },
  { id: 'tollocan', label: 'Zona Tollocan', gameZone: 'Toluca' },
  { id: 'ceu', label: 'Zona C.U.', gameZone: 'Paseo Colón' },
  { id: 'parque', label: 'Parque Sierra Morelos', gameZone: 'Toluca' },
];

export const getGameLocation = (id) => (
  GAME_LOCATIONS.find((location) => location.id === id) || GAME_LOCATIONS[0]
);

export const getRandomGameLocation = (random = Math.random) => (
  GAME_LOCATIONS[Math.floor(random() * GAME_LOCATIONS.length)] || GAME_LOCATIONS[0]
);
